module.exports = __webpack_public_path__ + "img/bg_ad2d49706.png";